


export const ASOCIACION_USER = "ASC"
export const AGENTE_ADUANAL_USER = "AGA"
export const NAVIERA_USER = "NUS"
